import React from "react";
import { Button, List, Space, Tooltip, Typography } from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
  MinusCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import { BatchJobItem } from "reducers/types";

interface Props {
  items: BatchJobItem[];
  renderDetails?: (item: BatchJobItem) => React.ReactNode;
  onRetry?: (key: string) => void;
}

const icon = (item: BatchJobItem) => {
  switch (item.status) {
    case "SUCCESS":
      return <CheckCircleOutlined style={{ color: "#52c41a" }} />;
    case "NO_DATA":
      return <MinusCircleOutlined style={{ color: "#bfbfbf" }} />;
    case "FAILED":
      return <CloseCircleOutlined style={{ color: "#ff4d4f" }} />;
    case "SKIPPED":
      return <StopOutlined style={{ color: "#bfbfbf" }} />;
    case "RUNNING":
      return <LoadingOutlined style={{ color: "#1890ff" }} />;
    default:
      return <ClockCircleOutlined style={{ color: "#faad14" }} />;
  }
};

// Per-item list of an itemized job. FAILED and SKIPPED items are retryable; NO_DATA is not (U7).
const JobItemList: React.FC<Props> = ({ items, renderDetails, onRetry }) => (
  <div style={{ maxHeight: 300, overflowY: "auto" }}>
    <List
      size="small"
      dataSource={items}
      renderItem={(item) => (
        <List.Item>
          <Space>
            {item.error ? <Tooltip title={item.error}>{icon(item)}</Tooltip> : icon(item)}
            <Typography.Text>{item.key}</Typography.Text>
            {renderDetails ? renderDetails(item) : null}
            {onRetry && (item.status === "FAILED" || item.status === "SKIPPED") ? (
              <Button size="small" danger onClick={() => onRetry(item.key)}>
                Retry
              </Button>
            ) : null}
          </Space>
        </List.Item>
      )}
    />
  </div>
);

export default JobItemList;
